import Repository from "./Repository";

export default abstract class StorageRespository<T> extends Repository<T> {
    protected readonly storage: Storage;

    constructor(key: string, storage: Storage) {
        super(key);
        this.storage = storage;
    }

    protected set(value: T): Promise<void> {
        return Promise.resolve(this.storage.setItem(this.storageKey, JSON.stringify(value)));
    }

    protected get(): Promise<T | undefined> {
        const item = this.storage.getItem(this.storageKey);
        return Promise.resolve(item !== null ? JSON.parse(item) : undefined);
    }

    protected clear(): Promise<void> {
        return Promise.resolve(this.storage.removeItem(this.storageKey));
    }
}
